module.exports = __webpack_public_path__ + "a567f4a8e101cb600004e09526a1a170.ttf";